import { render, staticRenderFns } from "./SaveDiffModal.vue?vue&type=template&id=143f6a70&scoped=true&"
import script from "./SaveDiffModal.vue?vue&type=script&lang=js&"
export * from "./SaveDiffModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveDiffModal.vue?vue&type=style&index=0&id=143f6a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f6a70",
  null
  
)

export default component.exports